// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-container-KkPe8 {
  width: fit-content;
}

.date-range-label-u3oP7 {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.date-range-icon-i8hYo {
  --size: 20px;
  flex-shrink: 0;
  color: var(--color-neutral-700);
}

.date-range-disabled-chSfk {
  opacity: 0.6;
  pointer-events: none;
}

.date-range-input-IOfcd {
  width: fit-content;
  height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: var(--color-neutral-900);
  padding: 0px 12px;
  cursor: pointer;
  user-select: none;
  transition: background-color 100ms, border-color 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
}

.date-range-input-IOfcd:hover {
  background-color: var(--color-neutral-50);
}

.date-range-input-IOfcd:active {
  background-color: var(--color-neutral-200);
}

.date-range-input-IOfcd:focus { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.date-range-value-rXN77 {
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.date-range-popup-wpOoi {
  min-width: max-content;
  background-color: white;
  border: 1px solid var(--color-neutral-200);
  box-shadow: var(--shadow-md);
  border-radius: var(--radius-xl);
  padding: 0px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/date-range/date-range.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gFAAgF;EAChF,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":[".container {\n  width: fit-content;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.icon {\n  --size: 20px;\n  flex-shrink: 0;\n  color: var(--color-neutral-700);\n}\n\n.disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.input {\n  width: fit-content;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: var(--color-neutral-900);\n  padding: 0px 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 100ms, border-color 0.2s ease, box-shadow 0.2s ease;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n}\n\n.input:hover {\n  background-color: var(--color-neutral-50);\n}\n\n.input:active {\n  background-color: var(--color-neutral-200);\n}\n\n.input:focus { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.value {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.popup {\n  min-width: max-content;\n  background-color: white;\n  border: 1px solid var(--color-neutral-200);\n  box-shadow: var(--shadow-md);\n  border-radius: var(--radius-xl);\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `date-range-container-KkPe8`,
	"label": `date-range-label-u3oP7`,
	"icon": `date-range-icon-i8hYo`,
	"disabled": `date-range-disabled-chSfk`,
	"input": `date-range-input-IOfcd`,
	"value": `date-range-value-rXN77`,
	"popup": `date-range-popup-wpOoi`
};
export default ___CSS_LOADER_EXPORT___;
